import React, { useState } from 'react';
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Card,
  CardBody,
} from 'reactstrap';
import FieldEditor from './FieldEditor';
import { TagMappingAdmin } from '../../TagMappingAdmin/TagMappingAdmin';
import { useOrganizationStore } from '../../../store/organization.store';

const FieldsManagement = () => {
  const [activeTab, setActiveTab] = useState('tab3');
  const isSuperAdmin = useOrganizationStore((state) => state.isSuperAdmin);

  return (
    <Card className="no-bg-card">
      <CardBody className="p-4 pb-5">
        <Row className="mt-4">
          <Col xs={12} className="pl-4 pr-4 pt-2 pb-2">
            <Nav tabs className="multi-tab">
              <NavItem>
                <NavLink
                  className={activeTab === 'tab3' ? 'active' : ''}
                  onClick={() => setActiveTab('tab3')}
                >
                  Producer
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab4' ? 'active' : ''}
                  onClick={() => setActiveTab('tab4')}
                >
                  Creative Director
                </NavLink>
              </NavItem>
              {/* Genre - Super Admin only (global collection) */}
              {isSuperAdmin && (
                <NavItem>
                  <NavLink
                    className={activeTab === 'tab7' ? 'active' : ''}
                    onClick={() => setActiveTab('tab7')}
                  >
                    Genre
                  </NavLink>
                </NavItem>
              )}
              {/* Tags - Super Admin only (global collection) */}
              {isSuperAdmin && (
                <NavItem>
                  <NavLink
                    className={activeTab === 'tab8' ? 'active' : ''}
                    onClick={() => setActiveTab('tab8')}
                  >
                    Tags
                  </NavLink>
                </NavItem>
              )}
              {/* Key - Super Admin only (global collection) */}
              {isSuperAdmin && (
                <NavItem>
                  <NavLink
                    className={activeTab === 'tab9' ? 'active' : ''}
                    onClick={() => setActiveTab('tab9')}
                  >
                    Key
                  </NavLink>
                </NavItem>
              )}
              {/* BPM - Super Admin only (global collection) */}
              {isSuperAdmin && (
                <NavItem>
                  <NavLink
                    className={activeTab === 'tab14' ? 'active' : ''}
                    onClick={() => setActiveTab('tab14')}
                  >
                    BPM
                  </NavLink>
                </NavItem>
              )}
              <NavItem>
                <NavLink
                  className={activeTab === 'tab10' ? 'active' : ''}
                  onClick={() => setActiveTab('tab10')}
                >
                  Composers
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab11' ? 'active' : ''}
                  onClick={() => setActiveTab('tab11')}
                >
                  Session Artists
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab12' ? 'active' : ''}
                  onClick={() => setActiveTab('tab12')}
                >
                  Studio
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab15' ? 'active' : ''}
                  onClick={() => setActiveTab('tab15')}
                >
                  Artist
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab16' ? 'active' : ''}
                  onClick={() => setActiveTab('tab16')}
                >
                  Album
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab17' ? 'active' : ''}
                  onClick={() => setActiveTab('tab17')}
                >
                  Record Label
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab18' ? 'active' : ''}
                  onClick={() => setActiveTab('tab18')}
                >
                  Publisher
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'tab19' ? 'active' : ''}
                  onClick={() => setActiveTab('tab19')}
                >
                  Backup Location
                </NavLink>
              </NavItem>
              {/* Tag Categories - Super Admin only */}
              {isSuperAdmin && (
                <NavItem>
                  <NavLink
                    className={activeTab === 'tab13' ? 'active' : ''}
                    onClick={() => setActiveTab('tab13')}
                  >
                    Tag Categories
                  </NavLink>
                </NavItem>
              )}
              {/* Client - Super Admin only (global collection) */}
              {isSuperAdmin && (
                <NavItem>
                  <NavLink
                    className={activeTab === 'tab1' ? 'active' : ''}
                    onClick={() => setActiveTab('tab1')}
                  >
                    Client
                  </NavLink>
                </NavItem>
              )}
              {/* Agency - Super Admin only (global collection) */}
              {isSuperAdmin && (
                <NavItem>
                  <NavLink
                    className={activeTab === 'tab2' ? 'active' : ''}
                    onClick={() => setActiveTab('tab2')}
                  >
                    Agency
                  </NavLink>
                </NavItem>
              )}
              {/* Flighting Platform - Super Admin only (global collection) */}
              {isSuperAdmin && (
                <NavItem>
                  <NavLink
                    className={activeTab === 'tab5' ? 'active' : ''}
                    onClick={() => setActiveTab('tab5')}
                  >
                    Flighting Platform
                  </NavLink>
                </NavItem>
              )}
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="tab3">
                {activeTab === 'tab3' && (
                  <FieldEditor
                    collectionName={'producer'}
                    type="single"
                    keyName={'producer'}
                  />
                )}
              </TabPane>
              <TabPane tabId="tab4">
                {activeTab === 'tab4' && (
                  <FieldEditor
                    collectionName={'creativedirector'}
                    type="multi"
                    keyName={'creativedirector'}
                  />
                )}
              </TabPane>
              {/* Flighting Platform - Super Admin only */}
              {isSuperAdmin && (
                <TabPane tabId="tab5">
                  {activeTab === 'tab5' && (
                    <FieldEditor
                      collectionName={'flightingplatform'}
                      type="multi"
                      keyName={'flightingPlatform'}
                    />
                  )}
                </TabPane>
              )}
              {/* Genre - Super Admin only */}
              {isSuperAdmin && (
                <TabPane tabId="tab7">
                  {activeTab === 'tab7' && (
                    <FieldEditor
                      collectionName={'genres'}
                      type="single"
                      keyName={'genre'}
                    />
                  )}
                </TabPane>
              )}
              {/* Tags - Super Admin only */}
              {isSuperAdmin && (
                <TabPane tabId="tab8">
                  {activeTab === 'tab8' && (
                    <FieldEditor
                      collectionName={'tags'}
                      type="multi"
                      keyName={'tags'}
                    />
                  )}
                </TabPane>
              )}
              {/* Key - Super Admin only */}
              {isSuperAdmin && (
                <TabPane tabId="tab9">
                  {activeTab === 'tab9' && (
                    <FieldEditor
                      collectionName={'keys'}
                      type="single"
                      keyName={'key'}
                    />
                  )}
                </TabPane>
              )}
              <TabPane tabId="tab10">
                {activeTab === 'tab10' && (
                  <FieldEditor
                    collectionName={'composers'}
                    type="multi"
                    keyName={'composer'}
                  />
                )}
              </TabPane>
              <TabPane tabId="tab11">
                {activeTab === 'tab11' && (
                  <FieldEditor
                    collectionName={'sessionartists'}
                    type="multi"
                    keyName={'sessionArtists'}
                  />
                )}
              </TabPane>
              <TabPane tabId="tab12">
                {activeTab === 'tab12' && (
                  <FieldEditor
                    collectionName={'studio'}
                    type="single"
                    keyName={'studio'}
                  />
                )}
              </TabPane>
              <TabPane tabId="tab15">
                {activeTab === 'tab15' && (
                  <FieldEditor
                    collectionName={'artists'}
                    type="single"
                    keyName={'artist'}
                  />
                )}
              </TabPane>
              <TabPane tabId="tab16">
                {activeTab === 'tab16' && (
                  <FieldEditor
                    collectionName={'albums'}
                    type="single"
                    keyName={'album'}
                  />
                )}
              </TabPane>
              <TabPane tabId="tab17">
                {activeTab === 'tab17' && (
                  <FieldEditor
                    collectionName={'recordlabels'}
                    type="single"
                    keyName={'recordLabel'}
                  />
                )}
              </TabPane>
              <TabPane tabId="tab18">
                {activeTab === 'tab18' && (
                  <FieldEditor
                    collectionName={'publishers'}
                    type="single"
                    keyName={'publisher'}
                  />
                )}
              </TabPane>
              <TabPane tabId="tab19">
                {activeTab === 'tab19' && (
                  <FieldEditor
                    collectionName={'backuplocation'}
                    type="single"
                    keyName={'backupLocation'}
                  />
                )}
              </TabPane>
              {/* Tag Categories - Super Admin only */}
              {isSuperAdmin && (
                <TabPane tabId="tab13">
                  {activeTab === 'tab13' && <TagMappingAdmin />}
                </TabPane>
              )}
              {/* BPM - Super Admin only */}
              {isSuperAdmin && (
                <TabPane tabId="tab14">
                  {activeTab === 'tab14' && (
                    <FieldEditor
                      collectionName={'bpm'}
                      type="single"
                      keyName={'bpm'}
                    />
                  )}
                </TabPane>
              )}
              {/* Client - Super Admin only */}
              {isSuperAdmin && (
                <TabPane tabId="tab1">
                  {activeTab === 'tab1' && (
                    <FieldEditor
                      collectionName={'client'}
                      type="single"
                      keyName={'client'}
                    />
                  )}
                </TabPane>
              )}
              {/* Agency - Super Admin only */}
              {isSuperAdmin && (
                <TabPane tabId="tab2">
                  {activeTab === 'tab2' && (
                    <FieldEditor
                      collectionName={'agency'}
                      type="single"
                      keyName={'agency'}
                    />
                  )}
                </TabPane>
              )}
            </TabContent>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default FieldsManagement;
